import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/error',
        name: 'error',
        component: () => import('./components/ErrorPage.vue'),
        props: (route) => {
            return {
                code: route.query.code,
                message: decodeURIComponent(String(route.query.message || 'Something went wrong.')),
                details: decodeURIComponent(String(route.query.details || '')),
            };
        },

        meta: {
            layout: 'blank',
        },
    },
] satisfies RouteRecordRaw[];
